import React from 'react';
import { useNavigation } from '../providers/NavigationContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

const BackButton = ({ label = 'Back', className = '' }) => {
  const { goBack } = useNavigation();

  return (
    <button
      onClick={goBack}
      className={`btn btn-link d-flex align-items-center mb-3 ${className}`}
      style={{ fontSize: '1.1rem', paddingLeft: 0 }}
    >
      <FontAwesomeIcon icon={faArrowLeft} className="me-2" />
      {label}
    </button>
  );
};

export default BackButton;
